<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZmJbET/media/FC-9781398487260.jpg?1695340701657" alt="This image is the cover for the book Heartful Business"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heartful Business
      </h1>
      <p class="bookDescription body article font2">
        <p>Heartful Business: Leading with the World in Mind is a provocation to everyone who’s a leader – to step up and join the battle to create a better world for all. And a battle it is. Governments and their leaders throw resources at problems for which they don’t have solutions, problems that keep growing and shapeshifting. The pressing need for a new leadership operating system for the world to survive, let alone thrive, is clear. We must solve the monumental problems facing our planet and humanity, for future generations to thrive. To do so will need a shift in how leaders lead as massive as the one we’re facing in our climate. The future isn’t just down to politicians. The challenge is too big. BUSINESS CAN LEAD THE WAY - by fundamentally committing to help create a better world for all. A handful of leaders get this but not enough. The thing is business leaders are ill-equipped to do what’s needed. WHAT’S NEEDED IS CONSCIOUS LEADERSHIP AND PRACTICAL ACTIONS THAT SET A ‘GREATER GOOD’ AT THE HEART OF THE ORGANISATION’S PURPOSE, VISION, CULTURE AND DAY-IN, DAY-OUT OPERATIONS. It’s about a new form of leadership based on five essential principles of human life expressed through five core qualities. From heartfulness, to greater reflection, to intentionality, to presence, to leading with more feminine qualities (irrespective of gender), Heartful Business: Leading with the World in Mind, sets out the standard and practices for the new era of leadership that’s fit for our times – describing why a new form of leadership is needed, what form it needs to take and, crucially, how to develop the capability to lead in this way. At whatever level you lead, Heartful Business will help you become the legacy-building leader you want to be and, more important, the world needs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lorraine Flower
      </h2>
      
      <p class="authorDescription body article">LORRAINE FLOWER With over 40 years in leadership and global business across multiple sectors and in senior leadership and consulting roles, Lorraine’s knowledge and understanding of the business world is extensive. Her belief in individual and organisational power for good fuels her deep commitment and vocational drive. Passionate about developing and exploring conscious leadership, Lorraine believes that business leaders are key players in transforming the well-being of the planet and humanity as a whole. TRUDY WORTH Ex-journalist, ex-PR, Trudy cut her leadership teeth heading teams in a 20-year-plus career in PR consultancy and working with senior teams in client organisations before a career change to organisation and leadership development. She’s passionate about the power of business and leaders to create a better world, enriching all, not just a shareholding few. Her work is dedicated to helping leaders at all levels develop greater consciousness of the world around them to make a positive difference inside their organisation and the world it serves.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17247720